import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { AuthService } from '../auth.service';

let refreshPromise: Promise<void> | null = null;

function isLoginRequest(url: string): boolean {
  return /\/auth\/?$/.test(url);
}

function isRefreshRequest(url: string): boolean {
  return url.includes('/auth/refresh');
}

function isLogoutRequest(url: string): boolean {
  return url.includes('/auth/logout');
}

function isMeRequest(url: string): boolean {
  return url.includes('/auth/me');
}

function shouldAttemptRefresh(url: string): boolean {
  return (
    !isLoginRequest(url) &&
    !isRefreshRequest(url) &&
    !isLogoutRequest(url) &&
    !isMeRequest(url)
  );
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const request = req.clone({ withCredentials: true });

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401 || !shouldAttemptRefresh(request.url)) {
        return throwError(() => error);
      }

      const hadUser = authService.isAuthenticated();

      if (!refreshPromise) {
        refreshPromise = authService.refreshSession().finally(() => {
          refreshPromise = null;
        });
      }

      // El catchError va solo sobre el refresh: un error del reintento es del endpoint, no de la sesión.
      return from(refreshPromise).pipe(
        catchError((refreshError) => {
          void authService.logout({ sessionExpired: hadUser });
          return throwError(() => refreshError);
        }),
        switchMap(() => next(request.clone({ withCredentials: true }))),
      );
    }),
  );
};
